import { render, staticRenderFns } from "./UserSharkManGame.vue?vue&type=template&id=fb898e98"
import script from "./UserSharkManGame.vue?vue&type=script&lang=js"
export * from "./UserSharkManGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports